import { Injectable } from '@angular/core';
import { injectEnvironment } from '../environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  env = injectEnvironment();

  isICloudEnabled() {
    return true;
  }
}
